/**
 *
 * getImageHeight 获取图片实际占位高度
 * @param {string} imgUrl 图片地址
 * @param {number} stlWidth 图片占位宽度,若不传，则取原图宽度
 * @returns imgHeight 图片实际占位高度
 */
function getImageHeight(imgUrl: string, stlWidth: number) {
  let imgHeight;
  try {
    const size = imgUrl.match(/(\d+)-(\d+)\.(?:png|jpg|gif)/) || [];
    const width = Number(size[1] || 0);
    const height = Number(size[2] || 0);
    if (stlWidth) {
      imgHeight = (height * stlWidth) / width;
    } else {
      imgHeight = height * 1;
    }
  } catch (ex) {
    imgHeight = 0;
  }
  return imgHeight;
}
export default getImageHeight;
